<!-- 안전리더십 > 컨텐츠수행 > 자유형식 -->
<template>
  <div class="tab-group ty01">
    <v-tabs
      v-model="tab"
    >
      <v-tab value="tabCont1" v-if="freeboardData.guideYn == 'Y' || freeboardData.fileYn=='Y'">{{t('message.guide')}}</v-tab>
      <v-tab v-for="(item,index) in fileList" :value="`tabCont${index+2}`">{{ t('message.documentViewer') }}</v-tab>
    </v-tabs>
  </div>
  <div class="pop-cont04">
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="tabCont1" v-if="freeboardData.guideYn == 'Y' || freeboardData.fileYn=='Y'">
        <div class="pop-cont04">
          <div class="form-group col-ty">
            <div class="editor-ty" v-html="freeboardData.content" v-if="freeboardData.guideYn == 'Y'">
            </div>
            <div class="editor-ty" v-html="''" v-if="freeboardData.guideYn != 'Y' && freeboardData.fileYn=='Y'">
            </div>
            <div class="form-group col-ty" v-if="freeboardData.fileYn=='Y'">
              <!--form-row-->
              <div class="form-row ty05">
                <div class="txt-tit ty04">{{t('message.attachSubmissionFile')}}</div>
                <div class="row">
                  <FileUpload v-model="freeboardData.files" :disabled="false" @change="onChangeImg" @delete="onDeleteImg"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tabs-window-item>
      <v-tabs-window-item v-for="(item,index) in fileList" :value="`tabCont${index+2}`" :key="item.idx??index+2">
        <div class="pdf-protect-wrapper"
             v-if="item.url && isPdf(item)"
             @contextmenu.prevent
             @mousedown.prevent.middle
             ref="wrap">
          <!-- 투명 오버레이: 마우스 이벤트를 먼저 잡음 -->
          <div class="pdf-overlay"
               @contextmenu.prevent
               @mousedown.prevent
               @dblclick.prevent></div>
          <PdfEmbed v-if="item.url" :source="item.url" />
        </div>
        <div v-else class="btn-area ty01">
          <p>{{t('message.documentNotSupportedByPdfViewer')}}</p>
          <c-btn01 :btnText="t('message.download')" @click.prevent="downloadFile(item)"/>
        </div>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
  <v-snackbar v-model="snackbar" :timeout="1500" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {useCommonStore} from "@/store/common";
import utils from "@/common/Utils";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import PdfEmbed from 'vue-pdf-embed';
import LeadershipService from "@/services/leadership.service";
import axios from "axios";
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps(['item', 'isActive'])
const emit = defineEmits(['complete','save'])

//bind
const snackbar = ref(false)
const snackText = ref('')
const tab = ref('')
const contentInfo:any = ref({})
const freeboardData:any = ref({})
const fileList:any = ref([])
const isEndMonitoring = ref(false)
const isPdf = (item:any) => item.filePath?.toLowerCase().endsWith('.pdf')

//hook
onUpdated(()=>{
})

//function
const getFreeboard=async()=>{
  try{
    tab.value = 'tabCont1'
    contentInfo.value = props.item
    const response = await LeadershipService.getFreeBoard({contentIdx:contentInfo.value.idx})
    if (response.success) {
      //데이터
      freeboardData.value = response.result
      //pdf데이터
      let filePaths = freeboardData.value.filePath?.split(',') || []
      let fileNames = freeboardData.value.fileName?.split(',') || []
      fileList.value = []
      _.forEach(filePaths, async (val, key) => {
        // ui 구성
        fileList.value.push({filePath:filePaths[key], fileName:fileNames[key], url:null})
      })


      //응답파일
      if(freeboardData.value.answerList != null) {
        //완료갯수 확인
        if(freeboardData.value.answerList.length >= contentInfo.value.periodCnt) {
          //완료처리
          //emit('complete', true)
          isEndMonitoring.value = true
          //제출파일 확인
          const answerList = freeboardData.value.answerList
          const maxPeriodSeq = _.maxBy(answerList, 'periodSeq')?.periodSeq
          const answer = answerList.filter(a => a.periodSeq === maxPeriodSeq)
          freeboardData.value.files = []
          _.forEach(answer, async (answerRow, answerKey) => {
            let filePaths = answerRow.filePath?.split(',') || []
            let fileNames = answerRow.fileName?.split(',') || []
            _.forEach(filePaths, async (val, key) => {
              //file input 셋팅
              const fileResponse = await fetch(utils.getBaseUrl("freeboard", filePaths[key]))
              if (!fileResponse.ok) {
                throw new Error(`download fail: ${fileResponse.statusText}`)
              }
              const blob = await fileResponse.blob()
              const imgFile = new File([blob], fileNames[key], {type: blob.type})
              freeboardData.value.files.push(imgFile)
            })
          })
        }
        else {  //미완료 처리
          //emit('complete', false)
          isEndMonitoring.value = false
        }
      }
      else {
        //emit('complete', false)
        isEndMonitoring.value = false
      }

      //종료 안됐으면
      if(!isEndMonitoring.value){
        // 완료조건 : 열람여부면 바로 완료체크
        if(contentInfo.value.criteriaType == '1'){
          //관찰자가(관리자) 아닐경우 완료체크
          if(!storeRef.isObserver.value)
            await completeProc()
        }
        else  //종료안됨 버튼활성화
          emit('complete', false)
      }
      else {  //종료 케이스
        //파일첨부여부 있으면 버튼 이름 변경
        if(freeboardData.value.fileYn=='Y')
          emit('complete', false, true)
        else
          emit('complete', true)
      }

    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//부모창에서 완료버튼 클릭
const childRefSave=async()=>{
  //종료됐는데 파일첨부 있으면 파일업로드 할꺼임
  if(isEndMonitoring.value && freeboardData.value.fileYn == 'Y'){
    if (utils.isEmpty(freeboardData.value.files) || freeboardData.value.files?.length <= 0) {
      snackText.value = t('message.fileSubmissionRequired')
      snackbar.value = true
      return
    }
    await uploadFileProc()
  }
  else {
    //파일첨부여부 타입으로 변경됨
    if (contentInfo.value.criteriaType == '4') {
      if (utils.isEmpty(freeboardData.value.files) || freeboardData.value.files?.length <= 0) {
        snackText.value = t('message.fileSubmissionRequired')
        snackbar.value = true
        return
      }
    }
    await completeProc()
  }
}

//완료저장
const completeProc=async ()=>{
  try {
    const formData = new FormData();
    freeboardData.value.files?.forEach((file) => {
      formData.append("files", file)
    })
    formData.append("leadershipIdx", freeboardData.value.leadershipIdx)
    formData.append("taskIdx", freeboardData.value.taskIdx)
    formData.append("contentIdx", freeboardData.value.contentIdx)
    formData.append("freeboardIdx", freeboardData.value.idx)
    formData.append("periodSeq", freeboardData.value.periodSeq)
    formData.append('companyIdx', localStorage.getItem('companyIdx'));

    const response = await LeadershipService.insertFreeBoardAnswer(formData)
    if (response.success){
      freeboardData.value.answerList.push(response.result)
      //열람여부가 아니면 알람미시지 노출
      if(contentInfo.value.criteriaType != '1') {
        snackText.value = t('message.submissionCompleted')
        snackbar.value = true
        //완료여부 부모로 전송. 부모창에서 알아서 닫기, !단 열람타입이 아닌경우만
        emit('save', true)
      }
      //answerList에 방금저장분 한개 추가
      if(freeboardData.value.answerList.length >= contentInfo.value.periodCnt) {
        if(freeboardData.value.fileYn=='Y')
          emit('complete', false, true)
        else
          emit('complete', true)
        isEndMonitoring.value = true
      }
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//파일만 업로드
const uploadFileProc=async ()=>{
  if(!freeboardData.value.answerList[0]?.idx)
    return;

  try {
    const formData = new FormData();
    freeboardData.value.files?.forEach((file) => {
      formData.append("files", file)
    })
    formData.append("freeBoardAnswerIdx", freeboardData.value.answerList[0]?.idx)

    const response = await LeadershipService.insertFreeBoardFile(formData)
    if (response.success){
        snackText.value = t('message.submissionCompleted')
        snackbar.value = true
        emit('save', true)
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onChangeImg=(e: Event)=>{
  utils.log(freeboardData.value.files)
}

const onDeleteImg=(item)=>{
  utils.log(freeboardData.value.files)
}

const downloadFile = async (item:any) => {
  const res = await axios.get(utils.getBaseUrl('freeboard', item.filePath), { responseType: 'blob' })

  const blob = new Blob([res.data])
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = item.fileName || 'download'
  a.click()

  URL.revokeObjectURL(url)
}

// watch
watch(tab, async (newTab, oldTab) => {
  const match = String(newTab || '').match(/(\d+)$/)
  const index = match ? Number(match[1]) : 1
  if (index <= 1) return

  const item = fileList.value[index-2]
  if (!item) return
  if (!isPdf(item)) return
  if (item.url) return

  const res = await axios.get(utils.getBaseUrl('freeboard', item.filePath),{ responseType: 'blob' })
  const blob = new Blob([res.data], { type: 'application/pdf' })
  item.url = URL.createObjectURL(blob)
})

watch(() => props.isActive, (val, oldVal) => {
  if (val)
    getFreeboard()
},{ immediate: true })

defineExpose({
  childRefSave,
})
</script>


<style lang="scss" scoped>
.pdf-protect-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* overlay가 PDF 위를 완전히 덮음 -> 우클릭/선택 직접 차단 */
.pdf-overlay{
  position: absolute;
  inset: 0;
  z-index: 10;
  /* 투명하지만 이벤트는 막음 */
  background: rgba(255,255,255,0);
  /* 선택 방지 */
  user-select: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;
}
</style>
